import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {getHasSearchAccountFilter} from '../../../../../store/featureFlags/featureFlagsSelectors';
import {InboxesSearchQueryBuilderDropdown} from './inboxesSearchQueryBuilderDropdown';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  hasSearchAccountFilter: getHasSearchAccountFilter,
}));

export const InboxesSearchQueryBuilderDropdownContainer = connect(mapStateToProps)(
  InboxesSearchQueryBuilderDropdown,
);
